<span *ngIf="loading"><div style="width: 34px; height: 34px;" class="loading-spinner"></div></span>
<button *ngIf="!loading" type="button" (click)="clicked($event)" class="{{ targetClass }}" [disabled]="disabled">{{ text }}</button>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/loading-button/loading-button.component.html